import React from 'react';

export default function ForwarderWallet({ lang }) {
  const ar = lang === 'ar';
  const L = (fr, a) => ar ? a : fr;
  const wallet = 5000;

  const plans = [
    { amount: 5000, accesses: 5 },
    { amount: 10000, accesses: 10 },
    { amount: 20000, accesses: 20 },
  ];

  return (
    <div style={{ maxWidth: 500, margin: '2rem auto', padding: '0 1rem' }}>
      <div className="card" style={{ textAlign: 'center' }}>
        <div style={{ fontSize: '0.75rem', color: 'var(--muted)' }}>{L('Solde actuel', 'الرصيد الحالي')}</div>
        <div style={{ fontSize: '2rem', fontWeight: 900, color: '#0c1425', margin: '0.3rem 0' }}>{wallet.toLocaleString()} DZD</div>
        <div style={{ fontSize: '0.78rem', color: 'var(--muted)' }}>{L(`= ${Math.floor(wallet / 1000)} accès demandes`, `= ${Math.floor(wallet / 1000)} وصول إلى الطلبات`)}</div>
      </div>

      <div className="card">
        <div className="card-title">💳 {L('Recharger', 'شحن المحفظة')}</div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
          {plans.map(p => (
            <button key={p.amount} className="btn btn-outline" style={{ justifyContent: 'space-between', width: '100%' }}>
              <span style={{ fontWeight: 700 }}>{p.amount.toLocaleString()} DZD</span>
              <span style={{ color: 'var(--muted)' }}>{p.accesses} {L('accès', 'وصول')}</span>
            </button>
          ))}
        </div>

        <div className="alert alert-info" style={{ marginTop: '1rem', fontSize: '0.78rem' }}>
          <span>🏦</span>
          <div>
            <strong>{L('Paiement par virement bancaire', 'الدفع عن طريق التحويل البنكي')}</strong><br />
            {L('RIB : 00799999 0000123456 78 — BEA', 'رقم الحساب: 00799999 0000123456 78 — BEA')}<br />
            {L('Envoyez votre reçu de virement à wallet@TidjarAIi.dz', 'أرسل إيصال التحويل إلى wallet@TidjarAIi.dz')}<br />
            {L('Activation sous 24h.', 'التفعيل خلال 24 ساعة.')}
          </div>
        </div>

        <div className="alert alert-warning" style={{ fontSize: '0.75rem' }}>
          💡 {L('Intégration CIB/Dahabia bientôt disponible.', 'دمج CIB/الذهبية قريباً.')}
        </div>
      </div>

      <div style={{ textAlign: 'center', marginTop: '1rem' }}>
        <a href="/transitaire/dashboard" style={{ fontSize: '0.82rem', color: '#6366f1' }}>← {L('Retour au dashboard', 'العودة إلى لوحة التحكم')}</a>
      </div>
    </div>
  );
}
